module.exports = __webpack_public_path__ + "56072e513c00c5d40259e96a0303fc76.pdf";